import { Box, Button, Grid, Typography } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';

const Project = ({ project }) => {
  return (
    <Grid item xs={12} md={4} className="projectBox">
      <Box
        sx={{
          p: 2,
          bgcolor: '#e1fcfb',
          borderRadius: 2,
          boxShadow: '1px 1px 20px rgba(46, 30, 102, 0.2)',
        }}
      >
        <Box>
          <img
            src={project.thumbnail}
            alt={project.name}
            style={{
              width: '100%',
              borderRadius: '5px',
            }}
          />
        </Box>
        <Box>
          <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
            {project.name}
          </Typography>
          <Typography>{project.overview}</Typography>
          <Link
            to={`/projects/${project.id}`}
            style={{ textDecoration: 'none' }}
          >
            <Button variant="contained" sx={{ mt: 2 }}>
              Details
            </Button>
          </Link>
        </Box>
      </Box>
    </Grid>
  );
};

export default Project;
